import { API_HOST, getHttpGetOptions, getHttpPostOptions } from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/verification`;

const getVerifyUserEndpoint = () => `${getEndpoint()}/verify/user`;
export const getVerifyUserRequest = () => [getVerifyUserEndpoint(), getHttpGetOptions()];

const getUploadVerificationDocumentEndpoint = () => `${getEndpoint()}/upload/document`;
export const getUploadVerificationDocumentRequest = (verificationDocument) => [
  getUploadVerificationDocumentEndpoint(),
  getHttpPostOptions(verificationDocument),
];

const getDeleteVerificationDocumentEndpoint = (documentSubject) =>
  `${getEndpoint()}/delete/document/${documentSubject}`;
export const getDeleteVerificationDocumentRequest = (documentSubject) => [
  getDeleteVerificationDocumentEndpoint(documentSubject),
  getHttpPostOptions(),
];

const getAddBrokerRoleEndpoint = () => `${getEndpoint()}/add-broker-role`;
export const getAddBrokerRoleRequest = () => [getAddBrokerRoleEndpoint(), getHttpPostOptions()];
